module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-6.6d771e8c.svg";